import DesignTokens from '@tableau/design-tokens';
import { cssRule } from 'typestyle';

import { applyColor }from '~src/style/ColorService';

cssRule('.tb-login, .tb-error-box', {
    transition: 'opacity 0.5s ease-in 1s',
    /* error: '-o-transition': 'opacity 0.5s ease-in 1s', */
    '-moz-transition': 'opacity 0.5s ease-in 1s',
    '-webkit-transition': 'opacity 0.5s ease-in 1s',
    /* error: '-khtml-transition': 'opacity 0.5s ease-in 1s', */
    position: 'absolute',
    top: '15%',
    right: 0,
    bottom: 0,
    left: 0,
    textAlign: 'center',
    minWidth: '500px',
});

cssRule('.tb-login.tb-signing-in', {
    '-ms-filter': '\'progid:DXImageTransform.Microsoft.Alpha(Opacity=100)\'',
    filter: 'alpha(opacity=100)',
    opacity: 1,
    display: 'block !important',
});

cssRule('.tb-login.tb-signing-in.ng-hide', {
    '-ms-filter': '\'progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\'',
    filter: 'alpha(opacity=0)',
    opacity: 0,
});

cssRule('.tb-login-title', {
    fontSize: '18px',
    fontWeight: 'normal',
    marginBottom: '18px',
    color: applyColor(DesignTokens.color.font.default.default, '#333'),
});

cssRule('.tb-login-logo', {
    marginBottom: '60px',
    display: 'inline-block',
    width: '90%',
});

cssRule('.tb-login-text-box', {
    display: 'block',
    width: '300px',
    marginLeft: 'auto',
    marginRight: 'auto',
    verticalAlign: 'top',
});

cssRule('.tb-login-text-box .tb-text-box-border', {
    border: '1px solid ' + applyColor(DesignTokens.color.elevation.border.default.default, '#cbcbcb'),
    borderRadius: '1px',
    /* error: '-o-border-radius': '1px', */
    /* error: '-moz-border-radius': '1px', */
    '-webkit-border-radius': '1px',
    /* error: '-khtml-border-radius': '1px', */
});

cssRule('.tb-login-text-box .tb-text-box-border:hover', {
    border: '1px solid ' + applyColor(DesignTokens.color.component.border.neutral.default.default, '#333'),
});

cssRule('.tb-login-text-box .tb-text-box-holder', {
    height: '34px',
});

cssRule('.tb-login-text-box .tb-text-box-input', {
    height: '30px',
    lineHeight: '30px',
    fontSize: '13px',
});

cssRule('.tb-login-text-box .tb-text-box-input:hover:not(:focus)', {
    background: applyColor(DesignTokens.color.elevation.surface.default.default, '#FAFAFA')+' !important',
});

cssRule('.tb-login-text-box .tb-border-with-focus', {
    border: '1px solid ' + applyColor(DesignTokens.color.utility.focus.default.default, '#3498DB')+' !important',
    /* error: '-moz-box-shadow': '0 0 4px 0 #3498db', */
    '-webkit-box-shadow': '0 0 4px 0 '+ applyColor(DesignTokens.color.utility.focus.default.default, '#3498db'),
    boxShadow: '0 0 4px 0 '+ applyColor(DesignTokens.color.utility.focus.default.default, '#3498db'),
});

cssRule('@supports (-webkit-overflow-scrolling: touch)', {
    $nest: {
        '.tb-login-text-box .tb-text-box-input': {
            fontSize: '16px',
        },
    }
});

cssRule('.tb-login-label', {
    textAlign: 'left',
    fontSize: '12px',
    display: 'block',
    color: applyColor(DesignTokens.color.font.default.secondary, '#4f4f4f'),
    margin: '0 0 4px 4px',
});

cssRule('@supports (-webkit-overflow-scrolling: touch)', {
    $nest: {
        '.tb-login-site-picker input': {
            fontSize: '16px !important',
        },
    }
});

cssRule('.tb-login-site-picker', {
    width: '90%',
    maxWidth: '450px',
    marginLeft: 'auto',
    marginRight: 'auto',
    position: 'relative',
    border: '1px solid ' + applyColor(DesignTokens.color.elevation.border.default.default, '#b2b2b2'),
    textAlign: 'left',
    marginTop: '6px',
    height: '50%',
    borderRadius: '2px',
    /* error: '-o-border-radius': '2px', */
    /* error: '-moz-border-radius': '2px', */
    '-webkit-border-radius': '2px',
    /* error: '-khtml-border-radius': '2px', */
});

cssRule('.tb-login-site-picker .tb-data-grid-cell, .tb-login-site-picker .tb-data-grid-row-background, .tb-login-site-picker .tb-data-grid-cell-text, .tb-login-site-picker .tb-data-grid-no-matching-results', {
    height: '34px',
    lineHeight: '34px',
    fontSize: '13px',
});

cssRule('.tb-login-site-picker input:first-child', {
    height: '30px',
});

cssRule('@media only screen and (max-device-width: 640px)', {
    $nest: {
        '.tb-login-site-picker-container': {
            minWidth: '0 !important',
            width: 'auto !important',
        },
        '.tb-login': {
            width: 'auto !important',
        },
    }
});

cssRule('.tb-login-site-picker-container', {
    minWidth: '500px',
});

cssRule('.tb-login-site-picker-container .tb-login-text-box', {
    width: '90%',
    maxWidth: '450px',
    position: 'relative',
});

cssRule('.tb-password-reset-msg', {
    marginTop: '20px',
});

cssRule('.tb-login-msg-container', {
    marginTop: '9px',
});

cssRule('.tb-login-msg', {
    display: 'inline-block',
    maxWidth: '550px',
    margin: '0 0 6px',
    textAlign: 'center',
    fontWeight: 'bold',
});

cssRule('.tb-password-reset-success', {
    fontSize: '18px',
    fontWeight: 'normal',
    lineHeight: '1.5em',
});

cssRule('.tb-restart-password-reset', {
    marginTop: '20px',
});

cssRule('.tb-password-reset-success-header', {
    marginBottom: '60px',
    display: 'inline-block',
    fontSize: '28px',
    fontWeight: 'normal',
});

cssRule('.tb-logout-msg', {
    display: 'inline-block',
    maxWidth: '500px',
    margin: '0 0 6px',
    padding: '18px 18px',
    textAlign: 'center',
    fontWeight: 'bold',
    fontSize: '15px',
    borderRadius: '1px',
    /* error: '-o-border-radius': '1px', */
    /* error: '-moz-border-radius': '1px', */
    '-webkit-border-radius': '1px',
    /* error: '-khtml-border-radius': '1px', */
});

cssRule('.tb-login-error', {
    color: applyColor(DesignTokens.color.font.default.error, '#a0131c'),
});

cssRule('.tb-login-success', {
    color: applyColor(DesignTokens.color.link.inline.default.active, '#1a699e'),
    border: '1px solid ' + applyColor(DesignTokens.color.link.inline.default.active, '#1a699e'),
});

cssRule('.tb-login-windows-credentials, .tb-login-forgot-password', {
    textAlign: 'center',
    paddingTop: '12px',
});

cssRule('.tb-sign-in-note-without-url', {
    fontFamily: '"BentonSans-Medium"',
    color: applyColor(DesignTokens.color.font.default.default, 'rgba(0,0,0,0.56)'),
});

cssRule('.tb-sign-in-note-with-url', {
    fontFamily: '"BentonSans-Medium"',
});

cssRule('.tb-button-login', {
    minWidth: '224px',
    border: '1px solid transparent',
});

cssRule('.tb-button-login:focus', {
    border: '1px solid ' + applyColor(DesignTokens.color.utility.focus.default.default, '#3498DB'),
    /* error: '-moz-box-shadow': '0 0 4px 0 #3498db', */
    '-webkit-box-shadow': '0 0 4px 0 '+ applyColor(DesignTokens.color.utility.focus.default.default, '#3498db'),
    boxShadow: '0 0 4px 0 '+ applyColor(DesignTokens.color.utility.focus.default.default, '#3498db'),
});

cssRule('.tb-button-init', {
    minWidth: '264px',
});

cssRule('.tb-login-notification-img', {
    display: 'inline-block',
    width: '400px',
    margin: '0 35px',
    verticalAlign: 'top',
});

cssRule('.tb-login-mobile', {
    minWidth: '100%',
});

cssRule('.tb-login-form-container-mobile', {
    margin: '0px',
});

cssRule('.tb-app-banner', {
    height: '70px',
    backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.default, '#FAFAFA'),
    minWidth: '300px',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center'
});

cssRule('.tb-app-banner-close', {
    width: '12px',
    height: '12px',
    margin: '29px 15px 29px 15px',
    float: 'left',
});

cssRule('.tb-banner-logo', {
    width: '48px',
    height: '48px',
    float: 'left',
    borderRadius: '8px',
    /* error: '-o-border-radius': '8px', */
    /* error: '-moz-border-radius': '8px', */
    '-webkit-border-radius': '8px',
    /* error: '-khtml-border-radius': '8px', */
    border: '1px solid ' + applyColor(DesignTokens.color.component.border.neutral.default.default, '#e1e1e1'),
    /* error: '-moz-box-shadow': 0, */
    /* error: '-webkit-box-shadow': 0, */
    boxShadow: '0',
    boxSizing: 'border-box',
    margin: '11px 0px 11px 0px',
});

cssRule('.tb-app-banner-text-area', {
    float: 'left',
    fontSize: '13px',
    fontWeight: 'normal',
    margin: '13px 0px 13px 0px',
    color: applyColor(DesignTokens.color.font.default.secondary, '#666'),
    lineHeight: 1.35,
    textDecoration: 'none',
});

cssRule('.tb-app-banner-dismiss-button', {
    position: 'absolute',
    right: '20px',
    top: '25px',
});

cssRule('.tb-app-banner-link-text', {
    color: applyColor(DesignTokens.color.link.inline.default.default, '#1a699e'),
    fontSize: '15px',
    display: 'block',
});

cssRule('.tb-app-banner-link-area', {
    padding: '4.5px 13px 4.5px 13px',
    float: 'left',
});

cssRule('.tb-accessible-site-picker .tb-text-box-input::-webkit-input-placeholder', {
    color: applyColor(DesignTokens.color.font.default.secondary, '#707070'),
});

cssRule('.tb-accessible-site-picker .tb-text-box-input::-moz-placeholder', {
    color: applyColor(DesignTokens.color.font.default.secondary, '#707070'),
});

cssRule('.tb-accessible-site-picker .tb-text-box-input:-moz-placeholder', {
    color: applyColor(DesignTokens.color.font.default.secondary, '#707070'),
});

cssRule('.tb-accessible-site-picker .tb-text-box-input:-ms-input-placeholder', {
    color: applyColor(DesignTokens.color.font.default.secondary, '#707070'),
});

cssRule('.tb-accessible-site-picker .tb-text-box-input::-webkit-input-placeholder', {
    fontStyle: 'normal',
});

cssRule('.tb-accessible-site-picker .tb-text-box-input::-moz-placeholder', {
    fontStyle: 'normal',
});

cssRule('.tb-accessible-site-picker .tb-text-box-input:-moz-placeholder', {
    fontStyle: 'normal',
});

cssRule('.tb-accessible-site-picker .tb-text-box-input:-ms-input-placeholder', {
    fontStyle: 'normal',
});

